import Error from '../model/Error';
import KindergartenHoliday from '../dto/KindergartenHoliday';
import axios from 'axios';
import moment from 'moment/moment';

export default class KindergartenHolidayRepository {

    static findByKindergartenAndYear(kindergartenId, year) {
        const query = null !== year ? ('?year=' + year) : '';
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/holidays${query}`)
                .then(response => resolve(response.data.data.map(data => KindergartenHoliday.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findYearsByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/holiday-years`)
                .then(response => resolve(response.data.data.years))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(kindergartenId, kindergartenHoliday) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/kindergartens/${kindergartenId}/holidays`, kindergartenHoliday.serialize())
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(kindergartenHolidays) {
        return Promise.all(kindergartenHolidays.map(kindergartenHoliday => {
            const data = {
                date: moment(kindergartenHoliday.date, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                description: kindergartenHoliday.description
            };
            return new Promise((resolve, reject) => {
                axios
                    .put(`/kindergarten-holidays/${kindergartenHoliday.id}`, data)
                    .then(() => resolve())
                    .catch(error => reject(Error.fromResponse(error.response)));
            });
        }));
    }

    static delete(kindergartenHolidayId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/kindergarten-holidays/${kindergartenHolidayId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static importHolidaysForKindergartenAndYear(kindergartenId, year) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/kindergartens/${kindergartenId}/holidays/import/${year}`)
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
